<template>
    <b-row class="contacto-principal" align-h="center">
        <b-col cols="12" lg="4">
        </b-col>
        <b-col cols="11" class="col-center mx-auto" lg="4">
            <p class="contacto-principal-content" style="width: 100%" v-html="content.content"></p>
        </b-col>
        <b-col cols="12" lg="4">
        </b-col>
        <b-col cols="12" lg="4">
        </b-col>
        <b-col cols="12" lg="5" class="col-center">
            <b-row>
                <b-col cols="12" style="padding: 0">
                    <b-col cols="11" class="contacto-principal-content-form mx-auto">
                        <!-- <formulario :content="formulario"/> -->
                        <formulario3 :content="formulario" />
                    </b-col>
                </b-col>
            </b-row>
        </b-col>
        <b-col cols="12" lg="3">
        </b-col>
    </b-row>
</template>
<script>
    import Formulario3 from '@/components/forms/Formulario3'

    export default {
        name: 'section-program',
        components: {
            Formulario3
        },
        props: {
            content: Object
        },
        data: () => ({
            formulario: {
                class_color: 'formulario-black',
                text_boton: 'Enviar',
                boton_img: false
            }
        }),
        computed: {}
    }
</script>
<style scoped>
</style>